import { useFieldTheme } from 'framework/field/hooks/useFieldTheme';

import { useInputContext } from '../context/InputContext';

import cn from './Input.module.scss';

export const InputText = () => {
  const {
    inputRef,
    placeholder,
    type,
    typed_value,
    text_align,
    disabled,
    onKeyDown,
    onChange,
    onFocus,
    onBlur,
    theme,
  } = useInputContext();

  const field_theme = useFieldTheme(theme?.field);
  return (
    <input
      className={cn.input}
      ref={inputRef}
      type={type}
      value={typed_value}
      onChange={(e) => onChange({ formatted_value: e.target.value, value: e.target.value })}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      onMouseDown={(e) => e.stopPropagation()}
      disabled={disabled}
      style={{ textAlign: text_align, padding: field_theme.general.padding }}
    />
  );
};
